import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ADDRESS_SEARCHER_OPTIONS, DEFAULT_ADDRESS_SEARCHER_OPTIONS, IAddressSearcherOptions } from '@df/ui/form/address-searcher';
import { AddressSearcherService } from '@df/ui/form/address-searcher.service';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { PcaAddressSearcherService } from './pca-address-searcher.service';

export function provideDfModulePca(config?: DeepPartial<IAddressSearcherOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: ADDRESS_SEARCHER_OPTIONS,
            useFactory: () => {
                return defaultsDeep(config, DEFAULT_ADDRESS_SEARCHER_OPTIONS);
            }
        },
        {
            provide: AddressSearcherService,
            useClass: PcaAddressSearcherService
        }
    ]);
}
